import { render, staticRenderFns } from "./ProposalDetailsModalLegend.vue?vue&type=template&id=a5b7c794&scoped=true&"
import script from "./ProposalDetailsModalLegend.vue?vue&type=script&lang=js&"
export * from "./ProposalDetailsModalLegend.vue?vue&type=script&lang=js&"
import style0 from "./ProposalDetailsModalLegend.vue?vue&type=style&index=0&id=a5b7c794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b7c794",
  null
  
)

export default component.exports